import Tracker from './tracker';

interface ITrackerProps {
  action: 'click_ReviewCart' | 'select_category';
  /** ga label */
  label: string;
}

class RelatedAccessoriesTracker extends Tracker {
  /** 数据上报 */
  tracing = ({ label, action }: ITrackerProps) => {
    try {
      this.commonTracker({
        category: `product_page_related_accessories`,
        action,
        label,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export default new RelatedAccessoriesTracker();
